import { SurveyDeployerPageResponseJSON } from './../Survey-Deployer-Page-Response-JSON';

export class PageHeaderResponseJSON extends SurveyDeployerPageResponseJSON {
    surveyDomainURL: String;
    pageHeader: String;
    description: String;
    surveyName: String;
    surveyUrlName: String;
    uploadedLogoPath: String;
    uploadedRightLogoPath: String;
    uploadedLeftLogoPath: String;
} 